import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

export const LoaderContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  z-index: 100;
  opacity: 0.7;
`;

export const Title = styled.h2`
  margin-bottom: 32px;
  font-size: 24px;
  line-height: 26px;
  font-weight: 400;
  color: #475466;
`;

export const ImageUser = styled.label`
  cursor: pointer;
  input {
    display: none;
  }
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  img {
    width: 69px;
    height: 69px;
    object-fit: cover;
  }
  span {
    font-size: 13px;
    line-height: 26px;
    font-weight: 400;
    color: #4a90e2;
  }
`;

export const ButtonSubmit = styled(Button)`
  margin: 30px 0 0 0;
`;

export const FormRow = styled(Form.Row)`
  margin: 0;
`;

export const FormInput = styled(Form.Control)`
  background-color: #e4e9f0 !important;
  width: 492px !important;
  height: 46px !important;
`;
